<template>
  <div class="goodCourse">
    <div class="goodCourseBox">
      <div class="goodCourseHead">
        <div class="logotop">
          <img
            src="https://wowsite.oss-cn-shenzhen.aliyuncs.com/public/uploads/course/logo.png"
            alt=""
          />
        </div>
        <div class="zaixian">
          <img
            src="https://wowsite.oss-cn-shenzhen.aliyuncs.com/public/uploads/course/zaixian.png"
            alt=""
          />
        </div>
        <div class="ren">
          <img
            src="https://wowsite.oss-cn-shenzhen.aliyuncs.com/public/uploads/course/renwu.png"
            alt=""
          />
        </div>
        <div class="copurdrTab">
          <div>专属定制课表</div>
          <div>1V1直播教学</div>
          <div>课程无限回看</div>
          <div>贴心助教服务</div>
        </div>
      </div>
      <div class="centent">
        <div class="goodCoursejpb">
          <div class="courseTitle">
            <img
              src="https://wowsite.oss-cn-shenzhen.aliyuncs.com/public/uploads/course/jingpingke.png"
              alt=""
            />
          </div>
          <div class="jpCourse" v-for="(item, index) in jpkdata">
            <div class="jpCouseSm">
              <div class="jpcover">
                <img :src="item.cover_image_url" alt="" />
              </div>
              <div class="jpcontent">
                <div class="jptitle">{{ item.title }}</div>
                <div class="jpPirce">
                  <div>￥{{ item.price }}/节</div>
                </div>
                <div class="buynow" @click="goexternal(item)">
                  <img
                    src="https://wowsite.oss-cn-shenzhen.aliyuncs.com/public/uploads/course/nowbuy.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="goodCoursejpb ds">
          <div class="courseTitle">
            <img
              src="https://wowsite.oss-cn-shenzhen.aliyuncs.com/public/uploads/course/dske.png"
              alt=""
            />
          </div>
          <div class="jpCourse" v-for="(item, index) in dskdata">
            <div class="jpCouseSm">
              <div class="jpcover">
                <img :src="item.cover_image_url" alt="" />
              </div>
              <div class="jpcontent">
                <div class="jptitle">{{ item.title }}</div>
                <div class="jpPirce">
                  <div>￥{{ item.price }}/节</div>
                </div>
                <div class="buynow" @click="goexternal(item)">
                  <img
                    src="https://wowsite.oss-cn-shenzhen.aliyuncs.com/public/uploads/course/nowbuy.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="goodCoursejpb">
          <div class="courseTitle why">
            <div class="whytitle">为什么选择我们？</div>
            <img
              src="https://wowsite.oss-cn-shenzhen.aliyuncs.com/public/uploads/course/wenhao.png"
              alt=""
            />
          </div>
          <div class="whycentent">
            <div class="whycententop">
              <div class="whycententopleft">
                <div>
                  <div>音乐窝</div>
                  <div>在线1V1精品课</div>
                </div>
              </div>
              <div class="whycententopright">传统音乐培训</div>
            </div>
            <div class="whycententop sm">
              <div class="whycententopleft sm">
                <div>系统化课程体系、标准化智能课件</div>
              </div>
              <div class="whycententopright sm">
                <div>教学内容杂乱、不成体系</div>
              </div>
            </div>
            <div class="whycententop sm">
              <div class="whycententopleft sm">
                <div>
                  知名音乐大师+资深全职教研团队 音乐院校人才定向培养、师资强大
                </div>
              </div>
              <div class="whycententopright sm">
                <div>教师团队薄弱 兼职教师、人员流失高</div>
              </div>
            </div>
            <div class="whycententop sm">
              <div class="whycententopleft sm">
                <div>1V1在线直播课堂 直播支持无限回看</div>
              </div>
              <div class="whycententopright sm">
                <div>线下或第三方平台授课 一次性课堂、不支持回看</div>
              </div>
            </div>
            <div class="whycententop sm">
              <div class="whycententopleft sm">
                <div>灵活预约排课、国内外均可授课 助教全程实时跟踪学习状况</div>
              </div>
              <div class="whycententopright sm">
                <div>上课时间地域受限</div>
              </div>
            </div>
            <div class="whycententop sm">
              <div class="whycententopleft sm">
                <div>
                  课后作业布置、1V1作业点评 高质量视频/伴奏、帮助巩固练习
                </div>
              </div>
              <div class="whycententopright sm">
                <div>课后练习全凭自律自觉</div>
              </div>
            </div>
          </div>
        </div>
        <div class="classProcess">
          <div class="classProcessBtn">上课流程</div>
          <div class="classProcessCard">
            <div class="classProcessCardSm">
              <div class="classProcessCardTitle">1.购课</div>
              <div class="classProcessCarddetails">
                <div class="clasProcesstitle">购课后联系客服排课</div>
                <div class="clasProcessdetails">
                  <div class="clasProcessdetailscentent">
                    <div class="bigdetailscentent">
                      <div>课前水平测试评估</div>
                      <div>量身定制专属课表</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="classProcessCardSm">
              <div class="classProcessCardTitle">2.排课</div>
              <div class="classProcessCarddetails">
                <div class="clasProcesstitle pk">课前发送专属直播链接</div>
                <div class="clasProcessdetails pk">
                  <div class="clasProcessdetailscentent">
                    <div class="bigdetailscentent">
                      <div>灵活预约排课， 学习更方便</div>
                      <div>专属助教督促， 不怕忘上课</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="classProcessCardSm">
              <div class="classProcessCardTitle">3.上课</div>
              <div class="classProcessCarddetails">
                <div class="clasProcesstitle sk">老师及学员进入直播间</div>
                <div class="clasProcessdetails sk">
                  <div class="clasProcessdetailscentent">
                    <div class="bigdetailscentent">
                      <div>1V1直播课堂， 连麦互动教学</div>
                      <div>支持无限回看， 随时随地学习</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="classProcessCardSm">
              <div class="classProcessCardTitle">4.课后</div>
              <div class="classProcessCarddetails">
                <div class="clasProcesstitle kh">课后巩固学习效果</div>
                <div class="clasProcessdetails kh">
                  <div class="clasProcessdetailscentent">
                    <div class="bigdetailscentent">
                      <div>高清视频/伴奏跟练， 巩固课堂知识</div>
                      <div>课后作业布置/点评， 学习进步更快</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="qa">
          <div class="qabigtitle">Q&A</div>
          <div class="qasm">
            <div class="Qbox">
              <div class="q">Q</div>
              <div class="qtext">零基础可以报学吗？</div>
            </div>
            <div class="Abox">
              <div class="a">A</div>
              <div class="atext">
                可以的。在线1对1精品课，使用的是音乐窝标准化课程体系，课程从初学-进阶到达人根据不同阶段水平设置教学目标、课程内容及学习计划
              </div>
            </div>
          </div>
          <div class="qasm">
            <div class="Qbox">
              <div class="q">Q</div>
              <div class="qtext">小朋友可以学吗？</div>
            </div>
            <div class="Abox">
              <div class="a">A</div>
              <div class="atext">
                4岁以上即可报学，年纪较小未能独自操作上课设备的小朋友需要在家长陪同下进行上课。
              </div>
            </div>
          </div>
          <div class="qasm">
            <div class="Qbox">
              <div class="q">Q</div>
              <div class="qtext">上课时间如何安排？</div>
            </div>
            <div class="Abox">
              <div class="a">A</div>
              <div class="atext">
                购课后，助教老师将通过微信/电话联系您，并根据您的意向上课时间与老师的时间进行排课，届时按约定好的时间进行上课。
              </div>
            </div>
          </div>
          <div class="qasm">
            <div class="Qbox">
              <div class="q">Q</div>
              <div class="qtext">上课形式是怎样的？</div>
            </div>
            <div class="Abox">
              <div class="a">A</div>
              <div class="atext">
                在线1对1精品课是以直播课的形式上课，课前需要提前在手机或者ipad下载并登录音乐窝app，开课前助教会发送课程直播间链接及密码，课前5分钟提前进入直播间即可。
              </div>
            </div>
          </div>
          <div class="logotop bottom">
            <img
              src="https://wowsite.oss-cn-shenzhen.aliyuncs.com/public/uploads/course/logoweiba.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "goodCourse",
  data() {
    return {
      jpkdata: [],
      dskdata: [],
    };
  },
  computed: {},
  components: {},
  methods: {
    getData(id) {
      var _t = this;
      _t.$API
        .getGoodsList({
          page: 1,
          page_size: 50,
          category_id: id,
        })
        .then((res) => {
          res.data.list.forEach((a) => {
            a.newprice = a.price.split(".")[1];
            if (Number(a.newprice) === 0) {
              a.price = a.price.split(".")[0];
            }
          });
          if (id == 1) {
            _t.jpkdata = res.data.list;
          } else if (id == 2) {
            _t.dskdata = res.data.list;
          }
        });
    },
    goexternal(e) {
      // console.log(e)
      var origin_id = e.origin_id;
      var weapp_path = e.weapp_path;
      var u = navigator.userAgent;
      var isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //IOS端
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
      if (!!isIos) {
        let data = {
          origin_id: origin_id,
          weapp_path: weapp_path,
        };
        window.webkit.messageHandlers.buyCourseNow.postMessage({
          oneParam: data,
        });
      }
      if (!!isAndroid) {
        App.openMini(origin_id, weapp_path);
      }
    },
  },
  mounted() {
    this.getData(1);
    this.getData(2);
  },
  created() {},
  beforecreate() {},
};
</script>
<style lang="scss" scoped>
.goodCourseBox {
  width: 100%;
  background: #07d1aa;
}
.goodCourseHead {
  position: relative;
  background: url("https://wowsite.oss-cn-shenzhen.aliyuncs.com/public/uploads/course/ditu.jpg");
  background-size: 100%;
}
.logotop {
  padding: 20px 0;
  text-align: center;
}
.logotop img {
  margin: 0 auto;
  width: 126px;
}
.zaixian {
  text-align: center;
}
.zaixian {
  margin: 0 auto;
  width: 226px;
  margin-bottom: 10px;
}
.ren {
  position: relative;
  width: 100%;
}
.ren img {
  width: 100%;
}
.copurdrTab {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 220px;
  position: absolute;
  top: 170px;
  right: 20px;
}
.copurdrTab div {
  background: #f8fb25;
  color: #1dac8d;
  border-radius: 11px;
  margin-bottom: 6px;
  font-size: 12px;
  font-weight: bold;
  width: 99px;
  height: 21px;
  line-height: 22px;
}
.centent {
  position: relative;
  margin-top: -85px;
}
.goodCoursejpb {
  width: 320px;
  margin: 0 auto;
  background: #fff;
  padding: 36px 14px;
  border-radius: 24px;
  margin-bottom: 35px;
  padding-bottom: 34px;
}
.courseTitle {
  text-align: left;
  margin-bottom: 31px;
}
.courseTitle img {
  width: 77px;
}
.courseTitle.why {
  font-size: 20px;
  color: #41525b;
  position: relative;
}
.whytitle {
  text-align: center;
  font-weight: 500;
}
.courseTitle.why img {
  width: 33px;
  height: auto;
  position: absolute;
  left: 70px;
  top: -20px;
}
.jpCourse {
  margin-bottom: 17px;
}
.jpCourse:last-child {
  margin-bottom: 0;
}
.jpCouseSm {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.jpcover {
  width: 161px;
  height: 108px;
  border-radius: 4px;
  overflow: hidden;
}
.jpcover img {
  height: auto;
  width: 100%;
}
.jpcontent {
  width: 145px;
  font-size: 14px;
  text-align: left;
}
.jptitle {
  font-size: 14px;
  color: #2a2a2a;
}
.jpPirce {
  display: flex;
  margin-top: 16px;
  margin-bottom: 16px;
  align-items: center;
}
.jpPirce div:nth-of-type(1) {
  color: #ff5c13;
  margin-right: 10px;
  font-weight: bold;
}
.buynow {
  height: 17px;
  width: 64px;
}
.buynow img {
  height: 100%;
  width: 100%;
}
.whycententop {
  width: 321px;
  height: 65px;
  background: url("https://wowsite.oss-cn-shenzhen.aliyuncs.com/public/uploads/course/xuanzhe.png")
    no-repeat;
  background-size: 100%;
  display: flex;
  color: #fff;
  font-size: 15px;
  align-items: center;
}
.whycententopleft {
  width: 191px;
  text-align: center;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
}
.whycententopright {
  width: 130px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
}
.whycententop.sm {
  background: none;
  height: 50px;
  margin-bottom: 4px;
}
.whycententopleft.sm {
  width: 188px;
  text-align: center;
  height: 100%;
  display: flex;
  align-items: center;
  background: #d6fcef;
}
.whycententopright.sm {
  width: 125px;
  height: 100%;
  display: flex;
  align-items: center;
  background: #ffeee0;
}
.whycententopleft.sm,
.whycententopright.sm {
  font-size: 10px;
  color: #41525b;
  text-align: left;
  justify-content: flex-start;
  padding-left: 15px;
}
.whycententopleft.sm div,
.whycententopright.sm div {
  position: relative;
}
.whycententopleft.sm div::after {
  position: absolute;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #45daba;
  left: -8px;
  top: 6px;
  content: "";
}
.whycententopright.sm div::after {
  position: absolute;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #feae4b;
  left: -8px;
  top: 6px;
  content: "";
}
.classProcess {
  padding: 20px 15px;
  padding-bottom: 43px;
}
.classProcessBtn {
  height: 40px;
  line-height: 42px;
  text-align: center;
  width: 180px;
  margin: 0 auto;
  border-radius: 20px;
  text-align: center;
  color: #1dac8d;
  background: #f8fb25;
  font-size: 18px;
  font-weight: bold;
}
.classProcessCard {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.classProcessCardSm {
  width: 165px;
}
.classProcessCardTitle {
  font-size: 20px;
  color: #fff;
  text-align: center;
  margin-top: 28px;
  margin-bottom: 12px;
  font-weight: bold;
}
.classProcessCarddetails {
  width: 100%;
  border-radius: 15rpx;
}
.clasProcesstitle {
  background: #27c6b2;
  text-align: center;
  height: 42px;
  width: 100%;
  border-radius: 15px 15px 0 0;
  line-height: 42px;
  color: #fff;
  font-size: 13px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.clasProcessdetails {
  background: url("https://wowsite.oss-cn-shenzhen.aliyuncs.com/public/uploads/course/liucheng1.png")
    no-repeat;
  background-size: 100%;
  height: 120px;
}
.clasProcesstitle.pk {
  background: #b29de0;
}
.clasProcesstitle.sk {
  background: #eeca40;
}
.clasProcesstitle.kh {
  background: #63addc;
}
.clasProcessdetails.pk {
  background: url("https://wowsite.oss-cn-shenzhen.aliyuncs.com/public/uploads/course/liucheng2.png")
    no-repeat;
  background-size: 100%;
}
.clasProcessdetails.sk {
  background: url("https://wowsite.oss-cn-shenzhen.aliyuncs.com/public/uploads/course/liucheng3.png")
    no-repeat;
  background-size: 100%;
}
.clasProcessdetails.kh {
  background: url("https://wowsite.oss-cn-shenzhen.aliyuncs.com/public/uploads/course/liucheng4.png")
    no-repeat;
  background-size: 100%;
}
.clasProcessdetailscentent {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}
.clasProcessdetailscentent .bigdetailscentent div {
  position: relative;
  font-size: 14px;
  padding-left: 15px;
  width: 130px;
  text-align: left;
}
.clasProcessdetailscentent .bigdetailscentent div:nth-of-type(2) {
  margin-top: 15px;
}
.clasProcessdetailscentent .bigdetailscentent div::after {
  position: absolute;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #feae4b;
  left: 0;
  top: 5px;
  content: "";
}
.qa {
  background: #f6f6f6;
  padding: 0 27px;
  padding-top: 29px;
  padding-bottom: 47px;
}
.qabigtitle {
  text-align: center;
  width: 180px;
  margin: 0 auto;
  border-radius: 20px;
  text-align: center;
  font-size: 22px;
  font-weight: bold;
  color: #41525b;
  margin-bottom: 29px;
  font-family: PingFang SC, PingFang SC-Semibold;
}
.Qbox,
.Abox {
  display: flex;
  margin-bottom: 21px;
}
.Abox {
  margin-bottom: 27px;
}
.q,
.a {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #dadada;
  font-size: 14px;
  margin-right: 14px;
  line-height: 20px;
  text-align: center;
  color: #fff;
}
.a {
  background: #45daba;
}
.qtext,
.atext {
  color: #2f4542;
  font-size: 12px;
  max-width: 286px;
  text-align: left;
  line-height: 22px;
}
.qtext {
  font-weight: bold;
}
.logotop.bottom {
  padding: 0;
  margin-top: 55px;
}
</style>

